import { render, staticRenderFns } from "./PhotoList.vue?vue&type=template&id=19cbb65a&scoped=true"
import script from "./PhotoList.vue?vue&type=script&lang=js"
export * from "./PhotoList.vue?vue&type=script&lang=js"
import style0 from "./PhotoList.vue?vue&type=style&index=0&id=19cbb65a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cbb65a",
  null
  
)

export default component.exports